export default __webpack_public_path__ + "static/media/youtube.699b1e7f.png";